<template>
    <b-collapse class="archive-section" :class="'is-level-' + level" :open="open" animation="">
        <template #trigger="props">
            <div class="archive-trigger" role="button" :aria-expanded="props.open">
                <i class="fas fa-fw caret mr-2" :class="props.open ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
                <i v-if="icon" class="fad fa-fw mr-2" :class="icon"></i>
                <span class="title-text">{{ title }}</span>
                <span v-if="count !== null" class="count ml-2">({{ count }})</span>
            </div>
        </template>
        <div class="archive-body">
            <slot/>
        </div>
    </b-collapse>
</template>

<script>
    /**
     * Shared collapsible section for record archives (completed courses,
     * conference records, earned certificates). Two visual levels:
     *   - group: a top-level grouping such as a certification (bold, underlined)
     *   - year:  a year bucket inside a group (smaller, indented body)
     * The convention across pages: current/actionable items render above these
     * sections in full; history collapses. When a page has only one group,
     * that group defaults open; year sections default open on the newest year.
     */
    export default {
        name: 'ArchiveSection',
        props: {
            title: {type: [String, Number], required: true},
            count: {type: Number, default: null},
            icon: {type: String, default: null},
            open: {type: Boolean, default: false},
            level: {
                type: String,
                default: 'year',
                validator: v => ['group', 'year'].includes(v),
            },
        },
    };
</script>

<style lang="scss" scoped>
    .archive-section {
        .archive-trigger {
            color: white;
            cursor: pointer;
            user-select: none;

            .caret {
                font-size: 0.75em;
                color: rgba(255, 255, 255, 0.6);
            }

            .count {
                font-weight: normal;
                color: rgba(255, 255, 255, 0.6);
            }

            &:hover .title-text {
                text-decoration: underline;
            }
        }

        &.is-level-group {
            margin-bottom: 1.5rem;

            > .collapse-trigger .archive-trigger {
                font-size: 1rem;
                font-weight: bold;
                padding-bottom: 0.4rem;
                margin-bottom: 1rem;
                border-bottom: 1px dashed rgba(255, 255, 255, 0.2);
            }

            > .collapse-content > .archive-body {
                padding-bottom: 0.5rem;
            }
        }

        &.is-level-year {
            margin-bottom: 0.75rem;

            > .collapse-trigger .archive-trigger {
                font-size: 0.9rem;
                font-weight: bold;
                margin: 0.5rem 0 0.75rem;
            }

            > .collapse-content > .archive-body {
                padding: 0.25rem 0 0.75rem 0.5rem;
            }
        }
    }
</style>
